import React, { createContext, useContext, useEffect, useState } from "react";
import { lightTheme, candlelightTheme } from "./theme";
import CandlelightCursor from "./CandlelightCursor";

const ThemeContext = createContext();

const setCSSVariables = (themeObj) => {
  Object.entries(themeObj).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value);
  });
};

export const ThemeProvider = ({ children }) => {
  // Centralized touch device detection function
  const detectTouchDevice = () => {
    const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isSmallScreen = window.innerWidth <= 1024;
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    return isMobile || (hasTouch && isSmallScreen);
  };

  const [isTouchDevice] = useState(detectTouchDevice);
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem("theme");
    const defaultTheme = isTouchDevice ? "light" : "candlelight";
    return saved || defaultTheme;
  });
  
  // Apply theme synchronously on initial load and changes
  useEffect(() => {
    const applyTheme = (themeName) => {
      const themeObj = themeName === "candlelight" ? candlelightTheme : lightTheme;
      setCSSVariables(themeObj);
      localStorage.setItem("theme", themeName);
      document.documentElement.setAttribute("data-theme", themeName);
    };

    applyTheme(theme);
  }, [theme]);

  const toggleTheme = () => {
    // On touch devices, candlelight mode doesn't make sense, so just return early
    if (isTouchDevice) {
      console.log("Candlelight mode disabled on touch devices");
      return;
    }
    
    console.log("Toggling theme from:", theme);
    setTheme((prev) => {
      const newTheme = prev === "light" ? "candlelight" : "light";
      console.log("Setting theme to:", newTheme);
      return newTheme;
    });
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, isTouchDevice }}>
      {children}
      <CandlelightCursor isActive={theme === "candlelight" && !isTouchDevice} />
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
